import { NavLink, useNavigate } from 'react-router-dom';
import { useGlobalSearchStore } from '../../stores/useGlobalSearchStore';
import Search from '../../uikit/search';
import logo from './images/technoBuildLogo1.svg';
import ProfileDropdown from './ProfileDropdown';
import NotificationDropdown from './NotificationDropdown';
import { useAuthStore } from '../../stores/useAuthStore';
function Header() {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);
  const showSearch = useGlobalSearchStore((state) => state.showSearch);
  const searchQueryKey = useGlobalSearchStore((state) => state.searchQueryKey);

  return (
    <header className="sticky top-0 z-40 flex-none w-full px-2 py-2 transition-colors duration-500 bg-white border-b max-xs:py-2 md:px-4 drop-shadow backdrop-blur border-slate-900/10 ">
      <div className="flex items-center justify-between">
        <div className="flex items-center h-9 gap-x-2">
          {/* <div className="md:hidden" onClick={() => navigate(-1)}>
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 1024 1024"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="#000000"
                d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z"
              />
              <path
                fill="#000000"
                d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"
              />
            </svg>
          </div> */}
          <NavLink to={`/`}>
            <img alt="logo" width={32} height={32} src={logo} />
          </NavLink>
          <NavLink to={`/`}>
            <h1 className={`text-black origin-left font-bold text-xl`}>
              Techno <span className="text-[#ff9900]">Build</span>
            </h1>
          </NavLink>
        </div>
        <div className="flex items-center gap-x-2">
          <NotificationDropdown />
          <ProfileDropdown
            onProfile={() => navigate('/profile')}
            onLogout={() => {
              logout();
              navigate('/login');
            }}
          />
        </div>
      </div>
    </header>
  );
}

export default Header;
